export default "__VITE_ASSET__X5P5nHBZ__"